/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetMarketMakerRebatesOptions,
  GetMarketMakerRebatesResponses,
} from '../types/GetMarketMakerRebates'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Get rebate configuration
 * {@link /v1/market-makers/:market_maker_id/rebates}
 */
export function getMarketMakerRebates<ThrowOnError extends boolean = true>(
  options: Options<GetMarketMakerRebatesOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetMarketMakerRebatesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/market-makers/{market_maker_id}/rebates',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetMarketMakerRebatesResponses, ThrowOnError>>,
  )
}
